export const TCT_DRAFT =
  "https://datatracker.ietf.org/doc/html/draft-jurkovikj-collab-tunnel-03";

export const TCT_MURL_PROFILE =
  "https://www.ietf.org/archive/id/draft-jurkovikj-collab-tunnel-03.html#tct-m-url-profile";

export const TCT_SITEMAP_PROFILE =
  "https://www.ietf.org/archive/id/draft-jurkovikj-collab-tunnel-03.html#tct-m-sitemap-profile";

export const TCT_CURL = "https://example.com/article/123";
export const TCT_MURL = "https://example.com/article/123/llm.json";
export const TCT_SITEMAP = "https://example.com/catalog-v2.json";

export const TCT_MURL_IDENTITY =
  '{"canonical_url":"https://example.com/article/123","content":"# Overview\\n\\nHTTP validators support efficient revalidation.","content_media_type":"text/markdown; charset=utf-8","language":"en","profile":"https://www.ietf.org/archive/id/draft-jurkovikj-collab-tunnel-03.html#tct-m-url-profile","title":"Understanding HTTP Validators"}';

export const TCT_MURL_ETAG =
  '"sha256-43c1f136eeba66647d603208cf894e8bf745c0fb39f05ea61e8989d75c4b465f"';

export const TCT_MURL_HINT =
  "sha256-43c1f136eeba66647d603208cf894e8bf745c0fb39f05ea61e8989d75c4b465f";

export const TCT_MURL_CONTENT_DIGEST =
  "sha-256=:Q8HxNu66ZmR9YDIIz4lOi/dFwPs58F6mHomJ11xLRl8=:";

export const TCT_SITEMAP_IDENTITY =
  '{"items":[{"cUrl":"https://example.com/article/123","etag":"sha256-43c1f136eeba66647d603208cf894e8bf745c0fb39f05ea61e8989d75c4b465f","lastModified":"2026-07-15T09:00:00Z","mUrl":"https://example.com/article/123/llm.json"}],"profile":"https://www.ietf.org/archive/id/draft-jurkovikj-collab-tunnel-03.html#tct-m-sitemap-profile","version":2}';

export const TCT_SITEMAP_ETAG =
  '"sha256-b43ea9a8d167f541a374fb7c0cbf0343d130b5d19313e7260c7151fd6002299a"';

export const TCT_SITEMAP_CONTENT_DIGEST =
  "sha-256=:tD6pqNFn9UGjdPt8DL8DQ9EwtdGTE+cmDHFR/WACKZo=:";

export const TCT_GZIP_BASE64 =
  "H4sIAAAAAAAACk2PTU/DQAxE/0rkXrNZoBcUxJ0bHAqnSpXZdRK3G2/keJMixH9HVHydZ/Rm3jsElCwcMB2KJmhhMJvm1ns64zglakIePapxSOSvb7ZQQ8hiJAYtbKrHhXRhWveyl4fd7qlaMHFEyzpXc5mmrFZR13FgEquUvmPO0vyRDiNFxoO9TQQtGJ3Nj6inmFe5q8KAOpPdF+vcLdSQUPqC/VeTBGqYNHec6N/zdV0bJuuarL1HDQMv5Dn6qNiZOxY95YVPRxdySvjqrIhQclfbZrAxbSyYG13R5H7INRjbZeFZIulsKJGlry6+L7++8PEJTMRx6U0BAAA=";

export const TCT_GZIP_LENGTH = 254;

export const TCT_GZIP_ETAG =
  '"sha256-ffa735506c91fcb86dc8b1215bd990a28e19dca49fd79e2417bbd4f92d891a4f"';

export const TCT_REWRITTEN_IDENTITY = `${TCT_MURL_IDENTITY} `;
